export const noteKeys = {
  all: () => ['notes'] as const,
  lists: () => [...noteKeys.all(), 'list'] as const,
  list: (personId: string) => [...noteKeys.lists(), personId] as const,
  categories: () => [...noteKeys.all(), 'categories'] as const,
}
